import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppWrapper from './AppWrapper';
import "./restored-prod.css";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/push-sw.js").catch(() => undefined);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <AppWrapper />
  </>
);
